import { ChevronLeft, ChevronRight, Download, MessageSquare } from "lucide-react";
import { Button } from "@/components/ui/button";

export default function SlideNavigation({
  currentSlide,
  totalSlides,
  onPrev,
  onNext,
  onGoToSlide,
  onToggleNotes,
  onExport,
  showNotes,
}) {
  return (
    <nav
      className="relative h-14 bg-white/90 backdrop-blur-sm border-t border-slate-200 flex items-center"
      data-testid="slide-navigation"
    >
      <div className="absolute top-0 left-0 right-0 h-[2px] bg-slate-100">
        <div
          className="h-full bg-blue-600 transition-all duration-300 ease-out"
          style={{ width: `${((currentSlide + 1) / totalSlides) * 100}%` }}
          data-testid="slide-progress-bar"
        />
      </div>

      <div className="flex items-center justify-between w-full px-4 sm:px-6">
        <div className="flex items-center gap-1">
          <Button
            variant="ghost"
            size="icon"
            onClick={(e) => {
              e.stopPropagation();
              onPrev();
            }}
            disabled={currentSlide === 0}
            data-testid="prev-slide-button"
            className="h-8 w-8"
          >
            <ChevronLeft className="h-4 w-4" />
          </Button>
          <span
            className="text-xs font-medium text-slate-500 min-w-[52px] text-center font-mono tabular-nums"
            data-testid="slide-counter"
          >
            {currentSlide + 1} / {totalSlides}
          </span>
          <Button
            variant="ghost"
            size="icon"
            onClick={(e) => {
              e.stopPropagation();
              onNext();
            }}
            disabled={currentSlide === totalSlides - 1}
            data-testid="next-slide-button"
            className="h-8 w-8"
          >
            <ChevronRight className="h-4 w-4" />
          </Button>
        </div>

        <div className="hidden sm:flex items-center gap-1">
          {Array.from({ length: totalSlides }, (_, i) => (
            <button
              key={i}
              onClick={(e) => {
                e.stopPropagation();
                onGoToSlide(i);
              }}
              className={`w-6 h-1.5 rounded-full transition-all duration-200 ${
                i === currentSlide
                  ? "bg-blue-600"
                  : i < currentSlide
                  ? "bg-slate-300"
                  : "bg-slate-200"
              }`}
              data-testid={`slide-dot-${i + 1}`}
            />
          ))}
        </div>

        <div className="flex items-center gap-1">
          <Button
            variant={showNotes ? "secondary" : "ghost"}
            size="sm"
            onClick={(e) => {
              e.stopPropagation();
              onToggleNotes();
            }}
            data-testid="toggle-notes-button"
            className="h-8 gap-1.5 text-xs"
          >
            <MessageSquare className="h-3.5 w-3.5" />
            <span className="hidden sm:inline">Notes</span>
          </Button>
          <Button
            variant="ghost"
            size="sm"
            onClick={(e) => {
              e.stopPropagation();
              onExport();
            }}
            data-testid="export-pdf-button"
            className="h-8 gap-1.5 text-xs"
          >
            <Download className="h-3.5 w-3.5" />
            <span className="hidden sm:inline">PDF</span>
          </Button>
        </div>
      </div>
    </nav>
  );
}
